/* global axios */
import ApiClient from './ApiClient';

class KanbanCardTemplatesAPI extends ApiClient {
  constructor() {
    super('kanban_card_templates', { accountScoped: true });
  }

  list() {
    return axios.get(this.url);
  }

  create(payload) {
    return axios.post(this.url, { kanban_card_template: payload });
  }

  update(id, payload) {
    return axios.patch(`${this.url}/${id}`, {
      kanban_card_template: payload,
    });
  }

  remove(id) {
    return axios.delete(`${this.url}/${id}`);
  }

  duplicate(id, name) {
    return axios.post(`${this.url}/${id}/duplicate`, { name });
  }

  setDefault(id) {
    return axios.post(`${this.url}/${id}/set_default`);
  }

  affectedItems(id) {
    return axios.get(`${this.url}/${id}/affected_items`);
  }
}

export default new KanbanCardTemplatesAPI();
